const translateCreateOrUpdateSickLeave = (errorCode: string|undefined) : string => {
    if (!errorCode) return '';
    
    switch (errorCode) {
        case 'invalid_sick_leave_type':
            return 'Ungültiger Krankmeldungstyp';
            
        case 'invalid_or_missing_from_date':
            return 'Ungültiges oder fehlendes Startdatum';
            
        case 'invalid_date_format':
            return 'Ungültiges Datumsformat';
            
        case 'from_date_cannot_be_after_to_date':
            return 'Das Startdatum kann nicht nach dem Enddatum liegen';
            
        case 'invalid_record_id':
            return 'Ungültige Datensatz-ID';
            
        case 'employee_is_not_allowed_to_edit_sick_leave_of_child':
            return 'Sie sind nicht berechtigt, die Krankmeldung des Kindes zu bearbeiten';
            
        case 'eau_is_not_a_boolean':
            return 'Der eAU-Status muss wahr oder falsch sein';
            
        case 'eau_not_supported_for_child':
            return 'eAU wird für Krankmeldungen von Kindern nicht unterstützt';
            
        case 'employee_is_not_allowed_to_access_client_sick_leave':
            return 'Sie sind nicht berechtigt, auf die Krankmeldung des Klienten zuzugreifen';
            
        case 'missing_client_id':
            return 'Fehlende Klienten-ID';
            
        default:
            return 'Ein unbekannter Fehler ist aufgetreten';
    }
}

export default translateCreateOrUpdateSickLeave